export enum INetworkDetailsPageTabs {
  Overview = 'overview',
  Subnets = 'subnets',
  Ports = 'ports',
}
